import { GitBranch, PackageCheck, ShieldCheck } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { SectionLabel } from '@/components/marketing/v2/SectionLabel';

type Card = { Icon: LucideIcon; title: string; body: string };

const CARDS: ReadonlyArray<Card> = [
  {
    Icon: GitBranch,
    title: 'Code ouvert',
    body: 'Velko POS est construit avec Tauri. Le code est public et vérifiable — rien ne tourne en cachette sur ta machine.',
  },
  {
    Icon: PackageCheck,
    title: 'Builds publics',
    body: 'Chaque version est compilée automatiquement et publiée sur GitHub Releases. Tu télécharges exactement ce qui a été construit.',
  },
  {
    Icon: ShieldCheck,
    title: 'Notarisation en cours',
    body: 'La signature Apple et la certification Microsoft sont en cours de mise en place. D\'ici là, le guide ci-dessus suffit.',
  },
];

export default function InstallWhySafeV2() {
  return (
    <section className="bg-charcoal-800 py-20 text-white md:py-24">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <SectionLabel tone="dark">En toute confiance</SectionLabel>
        <h2 className="mt-3 font-marketing-display text-[clamp(30px,4.2vw,54px)] font-bold leading-[1] tracking-[-0.035em] text-white">
          Pourquoi c'est <span className="text-lime-500">sûr.</span>
        </h2>
        <p className="mt-4 max-w-[620px] font-marketing-body text-[17px] leading-[1.55] text-charcoal-200">
          L'avertissement de ton système ne veut pas dire que l'app est dangereuse — juste qu'elle
          n'a pas encore de certificat payant. Voici ce qui te protège.
        </p>

        <div className="mt-12 grid gap-[2px] border-2 border-charcoal-700 bg-charcoal-700 md:grid-cols-3">
          {CARDS.map(({ Icon, title, body }) => (
            <div key={title} className="flex min-h-[230px] flex-col gap-4 bg-charcoal-800 px-7 py-8">
              <span className="flex h-12 w-12 items-center justify-center border-2 border-lime-500 bg-charcoal-900 text-lime-500">
                <Icon className="h-[22px] w-[22px]" strokeWidth={2} aria-hidden="true" />
              </span>
              <h3 className="font-marketing-display text-[20px] font-bold leading-[1.15] tracking-[-0.01em] text-white">
                {title}
              </h3>
              <p className="font-marketing-body text-[14px] leading-[1.55] text-charcoal-200">
                {body}
              </p>
            </div>
          ))}
        </div>

        <p className="mt-8 font-marketing-mono text-[11.5px] uppercase tracking-[0.08em] text-charcoal-300">
          App&nbsp;: Velko POS · Identifiant&nbsp;: com.esaas.pos · Installée dans&nbsp;: /Applications/Velko
          POS.app
        </p>
      </div>
    </section>
  );
}
